import React from 'react';
import FormSteps from '../FormSteps';
import { UserProfessionContextProvider } from '../../../../../contexts/userProfessionContext';

// Import SVG icons
import gameControllerIcon from '../../../../../assets/svg/onboarding/game-controller.svg';
import clapperIcon from '../../../../../assets/svg/onboarding/clapper.svg';
import headphoneIcon from '../../../../../assets/svg/onboarding/headphone.svg';

/**
 * ProfessionStep Component
 *
 * Step for selecting user's profession(s) with decorative floating icons
 *
 * @param {Object} formik - Formik instance with form state and methods
 * @param {Function} goToNextStep - Function to navigate to the next step
 * @param {Function} goToPreviousStep - Function to navigate to the previous step
 * @param {Array} professions - User's current professions
 * @param {Object} errors - Formik errors object
 * @param {Component} OnBoardingUserProfession - The profession selection component
 */
const ProfessionStep = ({
  formik,
  goToNextStep,
  professions,
  errors,
  OnBoardingUserProfession
}) => {
  const handleNext = () => {
    goToNextStep('professions');
  };

  return (
    <>
      {/* Fixed decorative icons */}
      <div className="profession-decorative-icons">
        <img
          src={gameControllerIcon}
          alt=""
          className="floating-icon icon-left"
          role="presentation"
        />
        <img
          src={clapperIcon}
          alt=""
          className="floating-icon icon-center"
          role="presentation"
        />
        <img
          src={headphoneIcon}
          alt=""
          className="floating-icon icon-right"
          role="presentation"
        />
      </div>

      {/* Form content */}
      <FormSteps
        header="What's your creative profession or expertise?"
        description="Choose the role that best describes your creative expertise."
        nextButton={handleNext}
      >
        <UserProfessionContextProvider
          professions={professions || []}
          error={errors.professions && 'This field is required'}
          hideTitle={true}
        >
          <OnBoardingUserProfession setFieldValue={formik.setFieldValue} />
        </UserProfessionContextProvider>
      </FormSteps>
    </>
  );
};

export default ProfessionStep;
